import { Dialog, DialogContent } from "@mui/material";
import { useEffect, useState } from "react";
import ConfirmDialog from "../../../../commons/dialog/confirmDialog";
import NewFormHeader from "../../../forms/headers/newFormHeader";
import NewConversationForm from "../../../messaging/newConversationForm";

const NewConversationModal = ({ open, handleClose, accident }) => {
  const [messageText, setMessageText] = useState("");
  const [confirmCloseOpen, setConfirmCloseOpen] = useState(false);

  useEffect(() => {
    if (!open) {
      setMessageText("");
      setConfirmCloseOpen(false);
    }
  }, [open]);

  const hasMessageText = messageText.trim().length > 0;

  const requestClose = () => {
    if (hasMessageText) {
      setConfirmCloseOpen(true);
      return;
    }

    handleClose();
  };

  const forceClose = () => {
    setConfirmCloseOpen(false);
    setMessageText("");
    handleClose();
  };

  return (
    <>
      <Dialog open={open} onClose={requestClose} maxWidth="md" fullWidth>
        <NewFormHeader formName="NUEVA CONVERSACIÓN" handleClose={requestClose} loading={false} />
        <DialogContent dividers sx={{ p: 3 }}>
          <NewConversationForm
            accident={accident}
            handleClose={requestClose}
            onSuccess={forceClose}
            onMessageChange={setMessageText}
          />
        </DialogContent>
      </Dialog>

      <ConfirmDialog
        open={confirmCloseOpen}
        handleClose={() => setConfirmCloseOpen(false)}
        handleConfirm={forceClose}
        title="CERRAR VENTANA"
        text="¿Está seguro que desea cancelar esta operación? En caso de aceptar, se perderá el mensaje ingresado."
      />
    </>
  );
};

export default NewConversationModal;
